 
import { Grid, Tooltip } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import {
  Columns,
  cellStyles3,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import React, { Dispatch, SetStateAction } from 'react';
import DownArrow from '../../_components/atoms/Icons/DownArrow';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { SingleCardComponentProps } from '../../pages/ExperiencePage';
import { truncateString } from './riskPatientDetailsHelper';
import { getFormatterForTitle } from './experienceHelper';

// utils/buildCohortCards.ts

type CohortItem = {
  title: string;
  subTitle: string;
  items: any[];
  aggregatedData?: [];
  aggregated_cost_column_1_header?: string;
  aggregated_cost_column_2_header?: string;
};

export const buildCohortCards = (
  transformed: CohortItem[],
  rawCohortData: any,
  setIsKpiPopUp: Dispatch<SetStateAction<boolean>>,
  setSelectedCohort: (matched: any) => void,
  handleNavigate: any,
): SingleCardComponentProps[] => {
  const fixedOrder = [
    'Top Spending Categories',
    'Surge in Spending',
    'Emerging Categories',
  ];

  const backgroundColorMap: Record<string, string> = {
    'Top Spending Categories': '#8396E21A',
    'Surge in Spending': '#E283831A',
    'Emerging Categories': '#E283DE1A',
  };

  const borderColorMap: Record<string, string> = {
    'Top Spending Categories': '#7D93ED40',
    'Surge in Spending': '#E2838340',
    'Emerging Categories': '#E283DE40',
  };

  const hasAnyData = transformed.some(
    (item) => item.items && item.items.length > 0,
  );

  if (!hasAnyData) {
    throw new Error('No cohort analysis data available');
  }
  return fixedOrder.map((t) => {
    const found = transformed.find((c) => c.title === t);
    const firstItemWithData = found?.items?.find(
      (item) => item.aggregated_data,
    );
    return {
      title: t,
      subTitle: found?.subTitle || '',
      backgroundColor: backgroundColorMap[t],
      borderColor: borderColorMap[t],
      items: found?.items || [],
      rawCohortData,
      aggregated_cost_column_1_header:
        found?.aggregated_cost_column_1_header || '',
      aggregatedColumn1Value:
        firstItemWithData?.aggregated_data?.aggregated_cost_column_1_value ||
        '',
      aggregated_cost_column_2_header:
        found?.aggregated_cost_column_2_header || '',
      aggregatedColumn2Value:
        firstItemWithData?.aggregated_data?.aggregated_cost_column_2_value ||
        '',
      setIsKpiPopUp,
      onArrowClick: (matched: any) => setSelectedCohort(matched),
      handleNavigate,
    };
  });
};

export const getKpiPopupColumns = (
  subTitle: string,
  aggregatedData?: any,
  aggregated_cost_column_1_header?: string,
  aggregated_cost_column_2_header?: string,
): Columns[] => {
  const baseColumns: Columns[] = [
    {
      name: 'Old Rank',
      align: 'center',
      cellStyles: cellStyles3,
      width: '20px',
      cellPadding: '0px 5px',
    },
    {
      name: 'Rank Jump',
      align: 'center',
      cellStyles: cellStyles3,
      width: '50px',
      cellPadding: '0px 5px',
    },
    {
      name: 'New Rank',
      align: 'center',
      cellStyles: cellStyles3,
      width: '50px',
      cellPadding: '0px 5px',
    },
    {
      name: 'Category',
      align: 'left',
      cellStyles: cellStyles3,
      width: '230px',
      cellPadding: '0px 5px',
    },
    {
      name: 'Category Type',
      align: 'left',
      cellStyles: cellStyles3,
      width: '200px',
      cellPadding: '0px 5px',
    },
  ];

  if (aggregatedData) {
    baseColumns.push({
      name: 'Percentage Change',
      align: 'center',
      cellStyles: cellStyles3,
      width: '120px',
      cellPadding: '0px',
    });
    baseColumns.push(
      {
        // name: `${aggregatedData.aggregated_cost_column_1_header || 'Column 2'}`,
        name: (
          <Grid style={{ alignItems: 'center' }}>
            <Typography fontSize="12px">Mo Avg</Typography>
            <Typography fontSize="12px">
              {aggregated_cost_column_1_header}
            </Typography>
          </Grid>
        ),
        align: 'center',
        cellStyles: cellStyles3,
        width: '150px',
        cellPadding: '0px',
      },
      {
        name: (
          <Grid style={{ alignItems: 'center' }}>
            <Typography fontSize="12px">Mo Avg</Typography>
            <Typography fontSize="12px">
              {aggregated_cost_column_2_header}
            </Typography>
          </Grid>
        ),
        align: 'center',
        cellStyles: cellStyles3,
        width: '150px',
        cellPadding: '0px',
      },
    );
  } else {
    baseColumns.push({
      name: subTitle,
      align: 'center',
      cellStyles: cellStyles3,
      width: '150px',
      cellPadding: '0px',
    });
  }

  baseColumns.push({
    name: 'Claimants',
    align: 'center',
    cellStyles: cellStyles3,
    width: '150px',
    cellPadding: '0px',
  });

  return baseColumns;
};

export const getKpiRowsFromCohort = (
  title: string,
  cohortSection: any,
  handleNavigate: any,
  reference_date?: any,
) => {
  const rowData: any[] = [];
  cohortSection?.forEach((item: any) => {
    const eachRow: any[] = [];
    eachRow.push(
      <Grid
        style={{
          width: '50px',
          display: 'flex',
          justifyContent: 'center',
          gap: '5px',
          alignItems: 'center',
          padding: '0 4px',
          height: '34px',
          flexShrink: 0,
          borderBottom: `1px solid #E5E9F0`,
        }}
      >
        <Typography fontSize="12px">{item?.cohort_old_rank}</Typography>
      </Grid>,
    ),
      eachRow.push(
        item?.cohort_trend === 'neutral' ? (
          <Typography
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            styleProps={{
              width: '50px',
              display: 'flex',
              gap: '5px',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 4px',
              height: '34px',
              borderBottom: `1px solid #E5E9F0`,
            }}
          >
            -
          </Typography>
        ) : (
          <Grid
            style={{
              width: '50px',
              display: 'flex',
              justifyContent: 'center',
              gap: '5px',
              alignItems: 'center',
              padding: '0 4px',
              height: '34px',
              flexShrink: 0,
              borderBottom: `1px solid #E5E9F0`,
            }}
          >
            <DownArrow
              fill={item?.cohort_trend === 'decreasing' ? `#00BDA5` : `#E8696D`}
              style={{
                transform:
                  item?.cohort_trend === 'decreasing'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
              }}
            />
            <Typography
              fontSize="12px"
              textColor={
                item?.cohort_trend === 'decreasing' ? `#00BDA5` : `#E8696D`
              }
            >
              {item?.cohort_rank_jump === '^' ? '' : item?.cohort_rank_jump}
            </Typography>
          </Grid>
        ),
      ),
      eachRow.push(
        <Grid
          style={{
            minWidth: '50px',
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            alignItems: 'center',
            padding: '0 4px',
            height: '34px',
            flexShrink: 0,
            borderBottom: `1px solid #E5E9F0`,
          }}
        >
          {' '}
          <Typography
            fontSize="12px"
            // textColor={
            //   item?.cohort_trend === 'decreasing'
            //     ? `${patientAccessTheme.palette.warning.main}`
            //     : `${patientAccessTheme.palette.status.success}`
            // }
          >
            {item?.cohort_new_rank}
          </Typography>
        </Grid>,
      ),
      eachRow.push(
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            borderBottom: `1px solid #E5E9F0`,
            height: '34px',
            // width: '80px',
          }}
        >
          <Tooltip
            disableFocusListener
            placement={'top-end'}
            title={<Typography fontSize="12px">{item.cohort_name}</Typography>}
            arrow={true}
          >
            <div
              onClick={() =>
                handleNavigate(
                  item.claimlevellookups_key,
                  item.claimlevellookups_value,
                  reference_date,
                  title,
                )
              }
            >
              <Typography
                fontSize="12px"
                fontType="medium"
                cursor="pointer"
                styleProps={{
                  textDecoration: 'underline dotted',
                  textUnderlineOffset: '3px',
                }}
                textColor={`${patientAccessTheme.palette.text.mediumemphasis}`}
              >
                {truncateString(item.cohort_name, 30)}
              </Typography>
            </div>
          </Tooltip>
        </Grid>,
      );
    eachRow.push(
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '34px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          borderBottom: `1px solid #E5E9F0`,
        }}
      >
        <Tooltip
          disableFocusListener
          placement={'top-end'}
          title={
            <Typography fontSize="12px">{item.cohort_category}</Typography>
          }
          arrow={true}
        >
          <div>
            <Typography
              fontSize="12px"
              fontType="medium"
              cursor="pointer"
              styleProps={{}}
              textColor={`${patientAccessTheme.palette.text.mediumemphasis}`}
            >
              {truncateString(item.cohort_category, 60)}
            </Typography>
          </div>
        </Tooltip>
      </Grid>,
    );
    if (item.aggregated_data) {
      const {
        aggregated_cost_column_1_value,
        aggregated_cost_column_2_value,
      } = item.aggregated_data;

      eachRow.push(
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '34px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            borderBottom: `1px solid #E5E9F0`,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            styleProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="12px"
          >
            {getFormatterForTitle(title)(item.value)}
          </Typography>
        </Grid>,
      );
      eachRow.push(
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '34px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            borderBottom: `1px solid #E5E9F0`,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            styleProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="12px"
          >
            {/* {aggregated_cost_column_1_value} */}
            {getFormatterForTitle('top spending')(
              aggregated_cost_column_1_value,
            )}
          </Typography>
        </Grid>,
      );

      // Push second aggregated column
      eachRow.push(
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '34px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            borderBottom: `1px solid #E5E9F0`,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            styleProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="12px"
          >
            {/* {aggregated_cost_column_2_value} */}
            {getFormatterForTitle('top spending')(
              aggregated_cost_column_2_value,
            )}
          </Typography>
        </Grid>,
      );
    } else {
      // Push single value column (no change)
      eachRow.push(
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '34px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            borderBottom: `1px solid #E5E9F0`,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            styleProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="12px"
          >
            {getFormatterForTitle(title)(item.value)}
          </Typography>
        </Grid>,
      );
    }

    eachRow.push(
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '34px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          borderBottom: `1px solid #E5E9F0`,
          justifyContent: 'center',
        }}
      >
        <Typography
          styleProps={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          fontSize="12px"
        >
          {item.unique_claimants_count}
        </Typography>
      </Grid>,
    );

    rowData.push(eachRow);
  });

  return rowData;
};

export const transformCohortData = (data: any) => {
  const statusMapper = (trend: string) => {
    if (trend === 'increasing') {
      return 'high';
    }
    if (trend === 'decreasing') {
      return 'low';
    }
    return '-';
  };

  const titleMap: { [key: string]: string } = {
    'top spending': 'Top Spending Categories',
    'surge in spending': 'Surge in Spending',
    'emerging spending': 'Emerging Categories',
  };
  const backgroundColorMap: { [key: string]: string } = {
    'top spending': '#8396E21A',
    'surge in spending': '#E283831A',
    'emerging spending': '#E283DE1A',
  };
  const borderColorMap: { [key: string]: string } = {
    'top spending': '#7D93ED40',
    'surge in spending': '#E2838340',
    'emerging spending': '#E283DE40',
  };
  const transformed = data?.map((section: any) => ({
    title: titleMap[section.analysis_type],
    subTitle: section.analysis_duration,
    backgroundColor: backgroundColorMap[section.analysis_type],
    borderColor: borderColorMap[section.analysis_type],
    aggregated_cost_column_1_header: section?.aggregated_cost_column_1_header,
    aggregated_cost_column_2_header: section?.aggregated_cost_column_2_header,
    items: section.result.slice(0, 3).map((item: any) => ({
      name: item.cohort_name,
      value:
        section.analysis_type === 'top spending' ? item?.value : item.value,
      status: statusMapper(item.cohort_trend),
      aggregated_data: item.aggregated_data,
      claimlevellookups_key: item.claimlevellookups_key,
      claimlevellookups_value: item.claimlevellookups_value,
    })),
  }));

  const fixedOrder = [
    'Top Spending Categories',
    'Surge in Spending',
    'Emerging Categories',
  ];

  transformed.sort(
    (a: any, b: any) =>
      fixedOrder.indexOf(a.title) - fixedOrder.indexOf(b.title),
  );
  return transformed;
};
